export default Object.freeze({
  APP_NAME: 'webapp',
  /**
   * 支持的语言列表
   */
  DEFAULT_LANG: 'zh_CN',
  LANG: {
    ZH_CN: {
      VALUE: 'zh_CN',
      TEXT: '简体中文',
      VALIDATOR(value) {
        return /^zh[-_]cn$|^zh$/i.test(value);
      }
    },
    ZH_HK: {
      VALUE: 'zh_HK',
      TEXT: '繁體中文(中國香港)',
      VALIDATOR(value) {
        return /^zh[-_]hk$/i.test(value);
      }
    },
    ZH_TW: {
      VALUE: 'zh_TW',
      TEXT: '繁體中文(中國台灣)',
      VALIDATOR(value) {
        return /^zh[-_]tw$/i.test(value);
      }
    },
    EN: {
      VALUE: 'en',
      TEXT: 'English',
      VALIDATOR(value) {
        return /^en/i.test(value);
      }
    },
    DE: {
      VALUE: 'de',
      TEXT: 'Deutsch',
      VALIDATOR(value) {
        return /^de/i.test(value);
      }
    },
    ES: {
      VALUE: 'es',
      TEXT: 'Español',
      VALIDATOR(value) {
        return /^es/i.test(value);
      }
    },
    FR: {
      VALUE: 'fr',
      TEXT: 'Français',
      VALIDATOR(value) {
        return /^fr/i.test(value);
      }
    },
    IT: {
      VALUE: 'it',
      TEXT: 'lingua italiana',
      VALIDATOR(value) {
        return /^it/i.test(value);
      }
    },
    JA: {
      VALUE: 'ja',
      TEXT: '日本語',
      VALIDATOR(value) {
        return /^ja/i.test(value);
      }
    },
    KO: {
      VALUE: 'ko',
      TEXT: '한국어',
      VALIDATOR(value) {
        return /^ko/i.test(value);
      }
    },
    PT: {
      VALUE: 'pt',
      TEXT: 'Português',
      VALIDATOR(value) {
        return /^pt/i.test(value);
      }
    },
    RU: {
      VALUE: 'ru',
      TEXT: 'русский',
      VALIDATOR(value) {
        return /^ru/i.test(value);
      }
    },
  },

  /**
   * 本地存储的键
   */
  STORAGE: {
    LANG: '$lang',
    DEBUG_SWITCH: '$debug_switch',
    DEBUG_LEVEL: '$debug_level',
    CLASSROOM: '$classroom'
  },

  /**
   * 三态常量
   */
  STATUS: {
    SUCCESS: 1000,
    FAIL: -1000,
    INITIAL: 0
  },
  MODEL_ENGINE: {
    LOCAL_STOREAG: 1203,
    SESSION_STORAGE: 1204,
    HTTP: 1205
  },

});



// WEBPACK FOOTER //
// ./src/constants/_global-keys.js